module.exports = __webpack_public_path__ + "static/media/icon_menu.75edf1de.svg";